import { Grid2 as Grid, TextField, GridSize } from "@mui/material"
import React from "react"
import useDebugInformation from "../../../hooks/useDebugInformation"
import { useAppSelector } from "@store/hooks"
import { StringProcessor } from "@utils/stringProcessor"
import { a11yProps } from "./helpers"
import { ServiceAgreementsInputs } from "@utils/BasicTypes"

export const MemoizedInputForCarePlan = React.memo<MemoizedCarePlanInputProps>(({ parent, prefix, notRequired, inputName, tabName, xs, sm, type, disabled }) => {
    const monitored = useAppSelector(({ ui }) => ui[`${inputName}`])

    const helperText = useAppSelector(({ ui }) => ui[`${inputName}HelperText`])
    const valid = useAppSelector(({ state }) => state[`${inputName}Valid`])
    const isValid = valid || notRequired?.includes(inputName)
    const label = StringProcessor.camelToWords(inputName.replace(prefix, ""))

    useDebugInformation(`${parent}▷[${inputName}]`, { inputName, prefix, xs, sm, monitored })
    return (
        (<Grid size={{ xs, sm }}>
            <TextField value={monitored} required {...a11yProps(inputName, prefix)} label={label} type={type} error={!isValid} color={isValid ? "primary" : "error"} helperText={!isValid ? helperText : ""} disabled={disabled} slotProps={{
                inputLabel: (type === "date" || type === "number") ? { shrink: true, } : {}
            }} />
        </Grid>)
    );
})

export type MemoizedCarePlanInputProps = {
    parent: string
    prefix: "CarePlanPlanDetailsProperty" | "CarePlanPlanDetailsBoiler" | "CarePlanPlanDetailsPlanOptions" | "CarePlanPlanDetailsOffer"
    tabName: "PolicyTab" | "PropertyTab" | "BoilerTab"
    inputName: ServiceAgreementsInputs
    xs: GridSize
    sm: GridSize
    type?: string
    notRequired?: string[]
    disabled?: boolean
}